import React, { FC } from 'react';

import { AccessGrant } from '@ariksa/inventory-core';
import { Box, HStack, Spinner } from '@chakra-ui/react';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

interface RoleGrantLinkProps {
  grant: AccessGrant;
  isLoading?: boolean;

  onClick(grant: AccessGrant): void;
}

/**
 * "via <role>" for a principal that reaches the resource through a role. A
 * listed role is searched for in this table, where its own row shows its
 * policies; any other role opens in the drawer.
 */
export const RoleGrantLink: FC<RoleGrantLinkProps> = props => {
  const { grant, isLoading, onClick } = props;
  const label = `via ${grant.name ?? grant.uuid ?? 'unknown role'}`;

  // A role that can be neither searched for nor opened stays plain text.
  if (!(grant.listed && grant.name) && !grant.uuid) return <Box>{label}</Box>;

  return (
    <CustomTooltip
      label={grant.listed ? 'Show this role in the list' : 'Open this role'}
    >
      <HStack
        as="button"
        type="button"
        spacing={1}
        maxW="full"
        color="primary"
        cursor="pointer"
        _hover={{ textDecoration: 'underline' }}
        onClick={e => {
          // A click on the row behind it opens the principal.
          e.stopPropagation();
          onClick(grant);
        }}
      >
        <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {label}
        </Box>
        {isLoading && <Spinner size="xs" color="primary" flexShrink={0} />}
      </HStack>
    </CustomTooltip>
  );
};
